<template>
    <v-dialog v-model="modalProp" persistent max-width="400">
        <v-card>
            <v-card-title
                class="headline green accent-4 white--text elevation-7"
            >
                Login Error
            </v-card-title>
            <div style="width:90%; margin:auto" class="text-justify">
                <v-card-text v-if="getModifierForUserLogin" class="my-5 subtitle-2">
                    Account is currently
                    <span class="font-weight-black">{{ getUserLoginStatus }}</span>. If you have concern with logging in please call
                    <span class="font-weight-black">HMI (02) 8811-1313</span>. Thank you!
                </v-card-text>
                <v-card-text v-else-if="getLoginErr === 'User does not exist'" class="my-5 subtitle-2">
                    <span style="display: block;margin-bottom: 10px;">This member code is not registered in our system.</span> Please double-check your member code, or if you have concerns please call
                    <span class="font-weight-black">HMI (02) 8811-1313</span>. Thank you!
                </v-card-text>
                <v-card-text v-else-if="getLoginErr === 'Check your member code/password'" class="my-5 subtitle-2">
                    <span style="display: block;margin-bottom: 10px;">The member code or password you entered is incorrect.</span> Please try again, or if you have concerns please call
                    <span class="font-weight-black">HMI (02) 8811-1313</span>. Thank you!
                </v-card-text>
                <v-card-text v-else class="my-5 subtitle-2">
                    <span style="display: block;margin-bottom: 10px;">{{ getLoginErr }}.</span> If you have concern with logging in please call
                    <span class="font-weight-black">HMI (02) 8811-1313</span>. Thank you!
                </v-card-text>
            </div>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="red darken-1"
                    text
                    @click="(modalProp = false)"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['loginStatus', 'getUserLoginStatus', ''],
    data: () => ({}),

    computed: {
        ...mapGetters(['getLoginErr', 'getModifierForUserLogin']),
        modalProp: {
            get() {
                return this.loginStatus
            },
            set(val) {
                this.$emit('loginStatusDiagShow', val)
            }
        }
    },
    methods: {
        refresh() {
            window.location.reload()
        }
    }
}
</script>

<style></style>
